import _ from 'lodash';
import {
  formatAiredDate,
  formatDurationInSeconds,
  formatMetadata,
  formatMovieMetadata,
  formatRating,
  formatSeasonEpisode,
  formatSubRatings,
  getItemBadge,
} from 'helpers/VideoHelper';
import {
  getNetworkLogoUrl,
  getContentTypeName,
  getVideoTypeName,
  isClip,
  isMovie,
  getDisplayBrand,
  isSportsContent,
} from 'helpers/ContentHelper';
import { stringToDate, isBetween, now } from 'helpers/DateTimeHelper';
import { isPlayerTypeHero } from 'helpers/PlayerHelper';
import videoContainerHeroTheme from './VideoContainerHero.module.scss';
import videoContainerStandardTheme from './VideoContainerStandard.module.scss';

export const getVideoContainerTheme = type =>
  isPlayerTypeHero(type) ? videoContainerHeroTheme : videoContainerStandardTheme;
export const getShouldCheckPreviewPass = type => !isPlayerTypeHero(type);
export const getShouldDisablePreviewPassRender = type => isPlayerTypeHero(type);

export const getVideoDetailProps = item => {
  if (!item) return null;

  const type = _.get(item, 'videoType', null);
  const name = _.get(item, 'name');
  const showCode = _.get(item, 'showCode');
  const description = _.get(item, 'description');
  const dateCreated = _.get(item, 'dateCreated');
  const originalAirDate = _.get(item, 'originalAirDate');
  const durationInSeconds = _.get(item, 'durationInSeconds');
  const subRatings = _.get(item, 'subRatings', []);
  const releaseYear = _.get(item, 'releaseYear');
  const contentRating = _.get(item, 'contentRating');
  const contentSKU = _.get(item, 'contentSKU') || _.get(item, 'contentSKUResolved', []);
  const network = _.get(item, 'network');
  const showNetworkBug = _.get(item, 'showNetworkBug', false);
  const seriesName = _.get(item, 'seriesName', name);
  const seriesType = _.get(item, 'seriesType');
  const sportTag = _.get(item, 'sportTag', null);
  const tuneIn = _.get(item, 'tuneIn', null);
  const actors = _.get(item, 'actors', null);
  const videoName = _.get(item, 'headline', name);
  const seriesScreenUrl = _.get(item, 'seriesScreenUrl');
  const creditCuePoint = _.get(item, 'creditCuePoint', null);
  const recommendationId = _.get(item, 'trackingData.properties.recommendationId', null);
  const displaySeasonAndEpisodeCounts = _.get(item, 'displaySeasonAndEpisodeCounts', true);
  const favoritableItems = _.get(item, 'favoritableItems');
  const videoTypeName = getVideoTypeName(type);
  const displayBrand = getDisplayBrand(item);
  const networkIcon = getNetworkLogoUrl(displayBrand);
  const duration = formatDurationInSeconds(durationInSeconds);
  const originalDate = isClip(type) ? dateCreated : originalAirDate;
  const seasonEpisode = displaySeasonAndEpisodeCounts
    ? formatSeasonEpisode(item.seasonNumber, item.episodeNumber)
    : '';
  const airDate = formatAiredDate(originalDate, '', 'M-D-YYYY');
  const rating = formatRating(contentRating);
  const badge = getItemBadge(item);
  const formatedSubRating = formatSubRatings(subRatings);
  const isSeriesDetailAvailable = _.get(item, 'isSeriesDetailAvailable', true);
  const ratingText = !rating && !formatedSubRating ? null : `${rating} ${formatedSubRating}`;
  const movieMetadataParams = { releaseYear, contentRating, subRatings, durationInSeconds };
  const movieMetadata = formatMovieMetadata(movieMetadataParams);
  const seriesMetadata = formatMetadata([airDate, ratingText, duration]);
  const metadata = isMovie(type) ? movieMetadata : seriesMetadata;
  const itemType = getContentTypeName(type);
  const title = seriesName;
  const subTitle = `${seasonEpisode}${videoName}`;
  const sportsSubTitle = isSportsContent(item) ? sportTag : null;
  const selectedSubtitle = sportsSubTitle || subTitle;
  const showSubtitle =
    title && title.toLowerCase() === selectedSubtitle.toLowerCase() ? null : selectedSubtitle;

  const props = {
    showCode,
    title,
    showSubtitle,
    metadata,
    description,
    badge,
    networkIcon,
    videoTypeName,
    tuneIn,
    actors,
    itemType,
    isSeriesDetailAvailable,
    type,
    network,
    seriesName,
    seriesType,
    seriesScreenUrl,
    showNetworkBug,
    creditCuePoint,
    contentSKU,
    recommendationId,
    favoritableItems,
  };
  return props;
};

export const getEndCardDuration = video => {
  if (!video) return null;
  const { creditCuePoint, videoType } = video;

  const {
    upNextDurationSeries,
    upNextDurationMovie,
    upNextDurationDefault,
  } = window.ExternalConfig;

  const noCreditCuePointUpNextDuration = 30;

  if (!creditCuePoint) return noCreditCuePointUpNextDuration;
  if (creditCuePoint <= upNextDurationSeries - 1) return creditCuePoint;
  if (creditCuePoint) return upNextDurationDefault;
  return isMovie(videoType) ? upNextDurationMovie : upNextDurationSeries;
};

export const isVideoLive = video => {
  const startDate = _.get(video, 'startDate', null);
  const endDate = _.get(video, 'endDate', null);

  if (!startDate || !endDate) return false;

  const starts = stringToDate(startDate);
  const ends = stringToDate(endDate);
  const current = now();
  const result = isBetween(current, starts, ends);

  return result;
};

export const getLiveVideo = ({ nextVideos }) => {
  if (!nextVideos) return null;
  const liveVideos = nextVideos.filter(video => isVideoLive(video));
  return liveVideos[0];
};
